import { useCallback } from "react";
import { useGlobalContext } from "../context/useGlobalContext"
import { useResto } from "./useResto";
import { getCheckingData, getInfoData, updateShiftConfig, updateResto } from "../services/userService";
import { useUser } from "./useUser";
import { useTransaction } from "./useTransaction";

const HOST_TERMS_ACCEPTED_KEY = "hostTermsAccepted";

const hasAcceptedTerms = (data) => {
    return Boolean(
        data?.acceptTerms ??
        data?.acceptedTerms ??
        data?.termsAccepted ??
        data?.accept_terms ??
        data?.accepted_terms
    );
};

export const useHost = () => {
    const { infoHost, setInfoHost, checkInHost, setCheckIn, hostActive, setHostActive, openModalTerms, setOpenModalTerms } = useGlobalContext();
    const { getResto, getPosition, getCountHost, getLikesCount, getCountryResto, getNotifyCount } = useResto();
    const { getAvatarUser } = useUser();
    const { getPoints, getRanking, getHostPosition } = useTransaction();

    const getInfoHost = useCallback(async () => {
        const res = await getInfoData();
        const acceptedInApi = hasAcceptedTerms(res);
        const acceptedLocally =
            typeof window !== "undefined" && window.localStorage.getItem(HOST_TERMS_ACCEPTED_KEY) === "true";
        setOpenModalTerms(!(acceptedInApi || acceptedLocally));
        setInfoHost(res);
        getAvatarUser(res?.cover, res?.name)
    }, [getAvatarUser, setOpenModalTerms, setInfoHost]);

    const getCheckIn = useCallback(async () => {
        const res = await getCheckingData();
        setCheckIn(res);
    }, [setCheckIn])

    const getDataHost = useCallback(() => {
        getInfoHost();
        getCheckIn();
    }, [getInfoHost, getCheckIn])

    const saveShiftConfig = useCallback(async (updatedShifts) => {
        const res = await updateShiftConfig({ shifts: updatedShifts });
        getDataHost();
    }, [])

    const updateRestoWork = useCallback(async (data) => {
        const res = await updateResto(data);
        
        // Recargar todos los datos relacionados con el nuevo resto
        try {
            await Promise.all([
                getDataHost(),
                getResto(),
                getPosition(),
                getCountHost(),
                getLikesCount(),
                getCountryResto(),
                getNotifyCount(),
                getPoints(),
                getRanking("resto"),
                getHostPosition()
            ]);
        } catch (error) {
            console.error('Error al recargar datos después de actualizar resto:', error);
        }
        
        return res;
    }, [getDataHost, getResto, getPosition, getCountHost, getLikesCount, getCountryResto, getNotifyCount, getPoints, getRanking, getHostPosition])

    const setActiveHost = useCallback((value) => {
        setHostActive(value);
    }, [setHostActive])

    const handleAccept = useCallback(async () => {
        if (typeof window !== "undefined") {
            window.localStorage.setItem(HOST_TERMS_ACCEPTED_KEY, "true");
        }
        setInfoHost((prev) => ({ ...(prev || {}), acceptTerms: true }));
        setOpenModalTerms(false);
        return true;
    }, [setOpenModalTerms, setInfoHost])

    const closeModalTerms = useCallback(() => {
        setOpenModalTerms(false)
    }, [setOpenModalTerms])

    return {
        infoHost,
        checkInHost,
        hostActive,
        openModalTerms,
        setActiveHost,
        getInfoHost,
        getCheckIn,
        getDataHost,
        saveShiftConfig,
        updateRestoWork,
        handleAccept,
        closeModalTerms,
    }
}   
